import React, { useState } from 'react';
import './PriceSummary.css';
import CouponModal from './CouponModal';


const PriceSummary = ({ isExpanded, onToggle }) => {
  const [useCarrot, setUseCarrot] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [couponCode, setCouponCode] = useState('');




  return (
    <>
      <div className="price-summary-card">
        <div className="summary-toggle-header">
          <h3 className="summary-title">Price Summary</h3>
          <button className="toggle-btn" onClick={onToggle}>
            {isExpanded ? 'Hide Details ▲' : 'Show Details ▼'}
          </button>
        </div>

        {/* Always visible */}
        <div className="summary-line total-pay collapsed-only">
          <strong>Amount Payable</strong>
          <strong>Rs 2010.00</strong>
        </div>

        {/* Expandable content */}
        {isExpanded && (
          <>
            {/* Carrot Balance */}
            <div className="carrot-box">
              <div className="carrot-header">
                <p>Available balance : 🥕<span>500</span></p>
              </div>
              <hr />
              <label className="carrot-checkbox">
                <input
                  type="checkbox"
                  checked={useCarrot}
                  onChange={() => setUseCarrot(!useCarrot)}
                />
                <span>Pay Using Carrot Balance</span>
              </label>
              <p className="usable-carrot">Usable Carrot Balance: 🥕50</p>
            </div>

            {/* Coupon Section */}
            <div className="coupon-box">
              <div className='coupon-code-box' >
                <input type="text" className="coupon-input"  value={couponCode} readOnly />
                <button onClick={() => setShowModal(true)}>Apply</button>
              </div>
              <p className="coupon-applied">Coupon applied for 10% instant discount</p>
            </div>

            {/* Summary */}
            <div className="summary-amounts">
              <div className="summary-line">
                <span>Grand Total</span>
                <span className="right-text">Rs 8000.00</span>
              </div>
              <div className="summary-line red">
                <span>Used Carrots</span>
                <span className="right-text">-Rs 50.00</span>
              </div>
              <div className="summary-line blue">
                <span>Coupon Discount</span>
                <span className="right-text">-Rs.400.00</span>
              </div>
            </div>

            {/* Booking Details */}
            <div className="booking-summary">
              <div className="summary-line">
                <strong>Booking Amount (Pay Now)</strong>
                <strong>Rs 2400.00</strong>
              </div>
              <p className="small-text">(30% of Grand Total)</p>

              <div className="charges">
                <div className="summary-line link">Platform & Other Charges <span>Rs 60.00</span></div>
                <div className="summary-line">GST <span>Rs 20.00</span></div>
                <div className="summary-line">Platform Fee <span>Rs 40.00</span></div>
              </div>
            </div>

            {/* Pay Later Box */}
            <div className="pay-later">
              <span className="tag">💎 Pay Later</span>
              <span className="right-text bold">Rs 5600.00</span>
            </div>
          </>
        )}

        {/* Always show Pay Now Button */}
        <div className='ps-pay-now-btn'>
        <button className="pay-now-btn">Rs.2010 Pay Now</button>
        </div>
      </div>
      <CouponModal show={showModal} onClose={() => setShowModal(false)} setCouponCode={setCouponCode} />
    </>
  );
};

export default PriceSummary;
